import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Progress } from 'antd';
import { useSelector } from 'react-redux';
import { getTheme } from 'Store/MultiDomain/MultiDomain.selector';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import Button from 'Components/UI/Button';
import { Icon } from 'Components/UI';
import Modal from 'Components/UI/Modal';
import { ActionButtonsWrapper, Wrapper } from './styles';

interface IAvisoRenderizacaoUpgrade {
  visible?: boolean;
  onCancel?: () => void;
}

const AvisoRenderizacaoUpgrade: FC<IAvisoRenderizacaoUpgrade> = ({
  visible,
  onCancel,
}) => {
  const whatsappContactLinkFlag = useFeatureFlag('whatsapp-contact-link');
  const whatsappContactLink =
    !whatsappContactLinkFlag.enabled && typeof whatsappContactLinkFlag.value === 'string'
      ? whatsappContactLinkFlag.value
      : process.env.REACT_APP_CONTACT_LINK || '';
  const linkHelpUrlFlag = useFeatureFlag('link-help-cta-viewer-2D');
  const linkHelpUrl = linkHelpUrlFlag.enabled && typeof linkHelpUrlFlag.value === 'string'
    ? linkHelpUrlFlag.value
    : 'http://help.maletadoengenheiro.com.br/';

  const { t } = useTranslation(['sharedModals', 'common']);
  const { colors } = useSelector(getTheme);

  const handleConfirm = () => {
    window.open(whatsappContactLink, '_blank');
  };

  const footerButtons = (
    <ActionButtonsWrapper>
      <Button
        className="buttonCancel"
        type='text'
        onClick={onCancel}
      >
        {t('common:cancel')}
      </Button>
      <Button
        className="buttonConfirm"
        type='primary'
        onClick={handleConfirm}
      >
        <Icon icon="whatsapp" customSize={16} className="iconInfoWrapper" />
        {t('sharedModals:avisoRenderizacao.requestCredits')}
      </Button>
    </ActionButtonsWrapper>
  )

  return (
    <Modal
      visible={visible}
      width={450}
      footerButtons={footerButtons}
      footerActive={false}
      customClassName
      onCancel={onCancel}
    >
      <Wrapper>
        <div className="header">
          <span className="title">
            {t('sharedModals:avisoRenderizacao.title')}
          </span>
          <Icon
            icon="cancelar"
            customSize={10}
            className="iconHeader"
            onClick={onCancel}
          />
        </div>

        <div className="contentWrapper">
          <div className="headerWrapper">
            <Progress
              type="circle"
              size={64}
              className="progressBar"
              percent={5}
              strokeWidth={8}
              strokeColor={colors.danger.danger}
              format={() => (
                <span className="progressCircleText">0</span>
              )}
            />
            <div className="rightHeaderWrapper">
              <span className="titleHeaderWrapper">
                {t('sharedModals:avisoRenderizacao.creditsTitle')}
              </span>
              <span className="descriptionHeaderWrapper">
                {t('sharedModals:avisoRenderizacao.creditsDesc')}
              </span>
            </div>
          </div>

          <div className="infoWrapper">
            <Icon icon="informacao" customSize={16} className="iconInfoWrapper" />
            <span className="textInfoWrapper">
              As mudanças no faturamento das renderizações se deve à nova política de preços da Autodesk. <a href={linkHelpUrl} className="textInfoInfoWrapper" target="_blank" rel="noopener noreferrer">Saiba mais</a> no nosso blog.
            </span>
          </div>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default AvisoRenderizacaoUpgrade;
